import {AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild} from "@angular/core";
import * as OV from 'online-3d-viewer';
import {FileSource, InputFile, ProjectionMode} from "online-3d-viewer";

@Component({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'viewer-3d',
  templateUrl: './viewer-3d.component.html',
  //styleUrls: ['./password-strength-meter.component.scss'],
})
export class Viewer3dComponent implements OnInit, AfterViewInit {
  @ViewChild('viewerDiv') viewerDiv;
  @Input()
  modelUrls: { url: string, file: string }[];
  viewer: OV.EmbeddedViewer;

  constructor() {
  }

  ngAfterViewInit(): void {
    setInterval(() => {
      if (this.viewerDiv.nativeElement.offsetParent && !this.viewer) {
        this.viewer = new OV.EmbeddedViewer(
          this.viewerDiv.nativeElement,
          {
            camera: new OV.Camera(
              new OV.Coord3D(100.0, 0.0, 0.0),
              new OV.Coord3D(0.0, 0.0, 0.0),
              new OV.Coord3D(0.0, 0.0, 1.0),
              90.0
            ),
            projectionMode: ProjectionMode.Orthographic,
            backgroundColor: new OV.RGBAColor(222, 222, 222, 255),
            defaultColor: new OV.RGBColor(200, 200, 200),
            edgeSettings: new OV.EdgeSettings(true, new OV.RGBColor(0, 0, 0), 20),
            onModelLoaded: ((m, a, b) => {
              (<any>window).viewer = this.viewer;
            }).bind(this)
          }
        );

        this.viewer.LoadModelFromInputFiles(
          this.modelUrls.map(u => new InputFile(u.file, FileSource.Url, u.url))
        );
      }
    }, 1000);
  }

  public ngOnInit() {
  }
}
